import { ChartingView } from './ChartingViewToggle.component'
import { preloadToothSVGs } from '../tooth-svgs/config/svg-registry'
import { ToothView } from '../tooth-svgs/types/tooth.types'

const preloadToothView = (
  toothNumber: number,
  view: ToothView,
): Promise<void> => preloadToothSVGs(toothNumber, view)

/**
 * Preload all tooth SVG assets required for the given chart view so the chart
 * can be shown without a numbers-only flash while lazy imports resolve.
 */
export async function preloadToothChartAssets(
  view: ChartingView,
): Promise<void> {
  const tasks: Promise<void>[] = []

  if (view === 'full' || view === 'upper') {
    for (let tooth = 1; tooth <= 16; tooth += 1) {
      tasks.push(preloadToothView(tooth, 'buccal'))
      tasks.push(preloadToothView(tooth, 'crown-top'))
    }
  }

  if (view === 'full' || view === 'lower') {
    for (let tooth = 17; tooth <= 32; tooth += 1) {
      tasks.push(preloadToothView(tooth, 'buccal'))
      tasks.push(preloadToothView(tooth, 'crown-bottom'))
    }
  }

  if (view === 'upper') {
    for (let tooth = 1; tooth <= 16; tooth += 1) {
      tasks.push(preloadToothView(tooth, 'palatal'))
    }
  }

  if (view === 'lower') {
    for (let tooth = 17; tooth <= 32; tooth += 1) {
      tasks.push(preloadToothView(tooth, 'lingual'))
    }
  }

  await Promise.all(tasks)
}
